import type { ShipmentDTO } from 'ecosystem'
import { stripRootShipping } from './stripRootShipping'

/**
 * Attach a single shipment to an order payload in the shape the BE
 * expects: strip the deprecated root-level shipping fields, lift
 * `shippingCost` (still root-level on the DTO), and set `shipments: [...]`.
 *
 * `built` undefined → returns the payload with the root shipping fields
 * stripped but no shipments set; useful for the "DEFAULT, no carrier" case
 * where there's no data to push.
 */
export const withShipment = <T extends object>(
  payload: T,
  built: { shipment: ShipmentDTO; shippingCost?: number } | undefined
) => {
  const stripped = stripRootShipping(payload as never)
  if (!built)
    return stripped as typeof stripped & { shipments?: ShipmentDTO[]; shippingCost?: number }
  return {
    ...stripped,
    ...(built.shippingCost !== undefined ? { shippingCost: built.shippingCost } : {}),
    shipments: [built.shipment]
  }
}
